<template>
  <KTCard :title="title" :subtitle="subTitle">
    <template v-slot:body>
      <!-- user form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- name -->
        <b-form-group
          label="Nombre *"
          label-for="name"
          description="Escriba el nombre del usuario"
        >
          <b-form-input
            id="name"
            v-model="user.firstName"
            type="text"
            required
            placeholder="Nombre"
          ></b-form-input>
        </b-form-group>
        <!-- lastname -->
        <b-form-group
          label="Apellidos *"
          label-for="lastname"
          description="Escriba los apellidos del usuario"
        >
          <b-form-input
            id="name"
            v-model="user.lastName"
            type="text"
            required
            placeholder="Apellidos"
          ></b-form-input>
        </b-form-group>
        <!-- email -->
        <b-form-group
          class="span-2"
          label="Email *"
          label-for="email"
          description="Escriba el email del usuario"
        >
          <b-form-input
            id="email"
            v-model="user.email"
            type="email"
            required
            placeholder="Email"
          ></b-form-input>
        </b-form-group>
        <!-- password -->
        <b-form-group
          label="Contraseña *"
          label-for="password"
          description="Escriba la contraseña del usuario"
        >
          <b-form-input
            id="password"
            v-model="user.password"
            type="password"
            required
            placeholder="Contraseña"
          ></b-form-input>
        </b-form-group>
        <!-- password check -->
        <b-form-group
          label="Repita la contraseña *"
          label-for="password"
          description="Escriba la contraseña otra vez"
        >
          <b-form-input
            id="password"
            v-model="password2"
            type="password"
            required
            placeholder="Contraseña"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-2">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import { ADD_USER, EDIT_USER } from "@/core/services/store/users.module";

export default {
  name: "users-add",
  components: {
    KTCard
  },
  data() {
    return {
      user: {
        id: null,
        firstName: "",
        lastName: "",
        email: "",
        password: ""
      },
      password2: ""
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar usuario" : "Nuevo usuario";
    },
    subTitle() {
      return this.isEdit
        ? "Modifique los datos del usuario"
        : "Escriba todos los datos del nuevo usuario";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  mounted() {
    if (this.isEdit) {
      this.user = this.$store.getters.user(this.$route.params.id);
      this.password2 = this.user.password;
    }
  },
  methods: {
    cancel() {
      this.$router.push("/users");
    },
    onSubmit() {
      if (this.user.password !== this.password2) {
        this.$bvToast.toast("Las contraseñas no coinciden", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        return;
      }
      if (this.isEdit) {
        this.$store.commit(EDIT_USER, this.user);
      } else {
        this.$store.commit(ADD_USER, this.user);
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
